<template>
  <ny-dialog
    class="ny-preview"
    size="large"
    :lock-scroll="false"
    v-model="visible"
    v-bind="$attrs"
    :before-close="handleBeforeClose"
  >
    <el-carousel
      ref="carousel"
      indicator-position="outside"
      arrow="always"
      v-bind="$attrs"
      :initial-index="initialIndex"
    >
      <el-carousel-item v-for="(item, index) in data" :key="index">
        <div class="ny-preview__content">
          <template v-if="typeof(item) === 'object'">
            <img v-if="item.type === 'IMG'" :src="item.value">
            <video ref="video" v-else-if="item.type === 'VIDEO'" controls :src="item.value"></video>
            <span v-else>{{item.value}}</span>
          </template>
          <template v-else>
            <img v-if="regexpImage.test(item) || dataType.toLowerCase() === 'img'" :src="item">
            <video
              ref="video"
              v-else-if="regexpVideo.test(item) || dataType.toLowerCase() === 'video'"
              controls
              :src="item"
            ></video>
            <span v-else>{{item}}</span>
          </template>
        </div>
      </el-carousel-item>
    </el-carousel>
  </ny-dialog>
</template>

<script>
import NyDialog from '../common/dialog'
import { _typeof } from '../../util/util'
import { REGEXP_IMAGE, REGEXP_VIDEO } from '../../util/constants';

export default {
  name: 'NyPreview',
  components: {
    NyDialog
  },
  props: {
    value: {
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    dataType: {
      type: String,
      default: 'TEXT'
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      visible: this.value,
      regexpImage: REGEXP_IMAGE,
      regexpVideo: REGEXP_VIDEO,
      typeof: _typeof
    }
  },
  methods: {
    handleBeforeClose (done) {
      if (this.$refs.video && this.$refs.video.length) this.$refs.video.forEach(video => video.pause())
      done()
    }
  },
  watch: {
    value (newVal) {
      this.visible = newVal
    },
    visible (newVal) {
      this.$emit('input', newVal)
      this.$emit('change', newVal)
    },
    initialIndex (newVal) {
      this.$refs.carousel && this.$refs.carousel.setActiveItem(newVal)
    }
  }
}
</script>

<style lang="scss">
@include b(ny-preview) {
  @include e(content) {
    position: relative;
    width: 90%;
    height: 480px;
    margin: 0 auto;

    img,
    video,
    span {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }

  .el-dialog {
    top: 10% !important;
    background: transparent;
    box-shadow: none;
  }

  .el-carousel__arrow {
    background: transparent;

    i {
      font-size: 40px;
    }
  }

  .el-dialog__close {
    font-size: 20px;

    &:hover {
      color: #3dc1c4;
    }
  }

  .el-carousel__container {
    height: 480px;
  }

  .el-carousel__indicator {
    button {
      height: 4px;
      background-color: white;
    }
    &.is-active {
      button {
        background-color: #3dc1c4;
      }
    }
  }
}
</style>
